const documentTitle = title => (document.title = `${title} | Twitter`);
export default documentTitle;
